import { Injectable } from '@angular/core';

import { PopoverComponent } from './popover.component';

@Injectable()
export class PopoverService {
  public popovers = [];

  public register(component: PopoverComponent) {
    this.popovers.push(component);
  }

  public unregister(component: PopoverComponent) {
    const index = this.popovers.indexOf(component);
    if (index >= 0) { this.popovers.splice(index, 1); }
  }
}
